import { jsxs, jsx } from "react/jsx-runtime";
import { Checkbox, CheckboxTheme } from "@wix/wix-ui-tpa/cssVars";
import classNames from "classnames";
import { useMemo, useRef, useCallback } from "react";
import { useFocusFieldEvent } from "../../contexts/events-context.js";
import { useForcedState, ForcedState } from "../../contexts/forced-state-context.js";
import styles from "../../ui/checkbox-group-field/checkbox-group-field-wut.module.scss";
import { classes } from "../../ui/checkbox-group-field/checkbox-group-field-wut.st.css";
import { NUMBER_OF_COLUMNS } from "../../ui/options-layout/options-layout-constants.js";
import { OtherOptionWUT } from "./other-option-wut.js";
import { Fieldset } from "../../ui/fieldset/fieldset.js";
import { OptionsLayout } from "../../ui/options-layout/options-layout.js";
const CheckboxGroupInputWUT = ({
  label,
  options,
  addOther,
  addOtherLabel,
  addOtherPlaceholder,
  required = false,
  value = null,
  onFocus,
  onBlur,
  disabled = false,
  otherInputCharacterLimit,
  numberOfColumns = NUMBER_OF_COLUMNS.ONE,
  hideBox = false,
  onChange,
  hasError,
  inputId,
  labelId,
  ariaDescribedBy,
  fieldId
}) => {
  const _value = useMemo(() => value || [], [value]);
  const forcedHover = useForcedState().includes(ForcedState.INPUT_FIELDS_HOVER);
  const firstCheckboxRef = useRef(null);
  const _onChange = useCallback(
    (newValue) => {
      onChange?.(newValue);
    },
    [onChange]
  );
  const handleChange = useCallback(
    (optionName, isChecked) => {
      const newValue = isChecked ? [..._value, optionName] : _value.filter((val) => val !== optionName);
      _onChange(newValue);
    },
    [_value, _onChange]
  );
  useFocusFieldEvent(() => {
    firstCheckboxRef.current?.focus({ preventScroll: true });
  }, fieldId);
  return /* @__PURE__ */ jsxs(
    Fieldset,
    {
      id: inputId,
      ariaLabelledBy: labelId,
      className: classNames(classes.checkboxGroup, {
        [classes.error]: hasError
      }),
      ariaDescribedBy,
      onFocus,
      onBlur,
      required,
      children: [
        /* @__PURE__ */ jsx(OptionsLayout, { numberOfColumns, children: options?.map(
          ({ label: optionLabel, value: optionValue, id: optionId }, index) => {
            const checkboxValue = optionValue ?? optionLabel;
            const isChecked = _value.includes(checkboxValue);
            return /* @__PURE__ */ jsx(
              Checkbox,
              {
                error: hasError,
                disabled,
                "data-hook": `checkbox-${optionLabel}`,
                checked: isChecked,
                onChange: (event) => {
                  handleChange(checkboxValue, event.checked);
                },
                name: label,
                label: optionLabel,
                className: classNames(classes.checkbox, styles.checkbox, {
                  [styles.checkboxError]: hasError,
                  [classes.hover]: forcedHover,
                  [classes.hideBox]: hideBox
                }),
                theme: hideBox ? CheckboxTheme.Box : CheckboxTheme.Default,
                ref: index === 0 ? firstCheckboxRef : void 0
              },
              `checkbox-${optionId || optionLabel}`
            );
          }
        ) }),
        /* @__PURE__ */ jsx(
          OtherOptionWUT,
          {
            label,
            options,
            addOther,
            addOtherLabel,
            addOtherPlaceholder,
            value,
            onChange: _onChange,
            disabled,
            hasError,
            maxLength: otherInputCharacterLimit
          }
        )
      ]
    }
  );
};
export {
  CheckboxGroupInputWUT
};
//# sourceMappingURL=checkbox-group-input-wut.js.map
